import { render, staticRenderFns } from "./ConversationNouveau.vue?vue&type=template&id=79a152f0&scoped=true"
import script from "./ConversationNouveau.vue?vue&type=script&lang=js"
export * from "./ConversationNouveau.vue?vue&type=script&lang=js"
import style0 from "./ConversationNouveau.vue?vue&type=style&index=0&id=79a152f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a152f0",
  null
  
)

export default component.exports